<div class="table-layout">
    <div class="table-operation">
        <button nButton
            id="front-table-client-cifs-share-refresh"
            style="float: right;"
            icon="icon-refresh"
            (click)="refresh()">
        </button>
        <n-button-group [relateTable]="dt"
            [items]="[addBtn, removeBtn]">
        </n-button-group>
    </div>
    <div class="table-container">
        <n-data-table #dt
            id="front-table-client-cifs-share-table"
            style="height: 4rem;"
            [config]="tableConfig"
            [columnDefs]="tableColumnDefs"
            [data]="tableData"
            [(selection)]="selection"
            [simpleMode]="SWITCH.IS_SIMPLE_MODE">
            <ng-template nTemplate
                [meta]="{field: 'PERMISSION'}"
                let-col
                let-data="rowData"
                *ngIf="supportTableEdit">
                <div class="interval-10"
                    *ngIf="data.editStatus">
                    <n-select id="permission-level-id" style="width: 1rem;" [options]="this.entry === FileSystemEntryE.AuditLog && !(this.selectFs?.isAuditLogFs && this.selectFs?.auditLogWritable) ? str.auditLogFsPermissionLevelOpts
                                                                         : str.permissionLevelOpts" [(ngModel)]="data[col.field]"
                        [ngModelOptions]="{standalone: true}">
                    </n-select>
                </div>
                <ng-container *ngIf="!data.editStatus">
                    <span>{{utilService.getLabelFromOptions(str.permissionLevelOpts, Number(data[col.field]))}}</span>
                </ng-container>
            </ng-template>
            <ng-template nTemplate
                [meta]="{field: 'buttons'}"
                let-col
                let-data="rowData"
                *ngIf="supportTableEdit">
                <div>
                    <ng-container *ngIf="data.editStatus">
                        <button nButton
                            id="edit_client_btn_{{data.id}}"
                            [label]="i18n.btn.okBtn"
                            [theme]="'text'"
                            (click)="confirmClient(data)">
                        </button>
                        <button nButton
                            id="delete_client_btn2_{{data.id}}"
                            [label]="i18n.btn.cancelBtn"
                            [theme]="'text'"
                            (click)="cancelModifyClient(data)"
                            style="margin-left: 8px;">
                        </button>
                    </ng-container>
                    <ng-container *ngIf="!data.editStatus">
                        <button nButton
                            id="confirm_client_btn_id_{{data.id}}"
                            [label]="i18n.btn.modifyBtn"
                            [theme]="'text'"
                            (click)="modifyClient(data)">
                        </button>
                        <button nButton
                            id="delete_client_btn1_{{data.id}}"
                            [label]="i18n.btn.deleteBtn"
                            [theme]="'text'"
                            (click)="deleteClient(data)"
                            style="margin-left: 8px;">
                        </button>
                    </ng-container>
                </div>
            </ng-template>
        </n-data-table>
    </div>
</div>
